import Table from 'react-bootstrap/Table';
import { useTable, useSortBy } from 'react-table';
import { useMemo } from 'react';
import Button from 'react-bootstrap/Button';

function OrganizerUsersTable({
  userList,
  chosenOrganizerUser,
  onInactivate,
  onActivate,
  onEdit,
}) {
  const data = useMemo(() => userList, [userList]);

  const columns = useMemo(
    () => [
      {
        Header: 'Namn',
        accessor: 'name',
        className: 'p-3',
        style: { width: '30%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{value}</div>
        ),
      },
      {
        Header: 'E-post',
        accessor: 'email',
        className: 'p-3',
        style: { width: '30%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>{value}</div>
        ),
      },
      {
        Header: 'Senast inloggad',
        accessor: 'loggedInDate',
        className: 'p-3',
        style: { width: '30%' },
        Cell: ({ cell: { value } }) => (
          <>
            {value.charAt(0) === '0' ? (
              <div className='d-flex gap-1'>-</div>
            ) : (
              <div className='d-flex gap-1'>{value.split('T')[0]}</div>
            )}
          </>
        ),
      },
      {
        Header: '',
        accessor: 'inactivate/reactivate',
        className: 'p-3',
        Cell: (props) => (
          <>
            {props.row.original.isActive ? (
              <div
                className='d-flex gap-2 justify-content-end always-active'
                role='button'
                onClick={() => {
                  chosenOrganizerUser(props.row.original);
                  onInactivate();
                }}
              >
                <span className='material-symbols-outlined'>
                  do_not_disturb_on
                </span>
                <span>Inaktivera</span>
              </div>
            ) : (
              <div
                className='d-flex gap-2 justify-content-end always-active'
                role='button'
                onClick={() => {
                  chosenOrganizerUser(props.row.original);
                  onActivate();
                }}
              >
                <span className='material-symbols-outlined'>add_circle</span>
                <span>Aktivera</span>
              </div>
            )}
          </>
        ),
      },
      {
        Header: '',
        accessor: 'edit',
        className: 'd-flex gap-1 justify-content-end',
        Cell: (props) => (
          <Button
            variant='outline-primary'
            className='d-flex align-items-center'
            disabled={!props.row.original.isActive}
            onClick={() => {
              chosenOrganizerUser(props.row.original);
              onEdit();
            }}
          >
            <span
              className='material-symbols-outlined me-2'
              style={{ fontSize: '18px' }}
            >
              edit
            </span>
            Redigera
          </Button>
        ),
      },
    ],
    [userList, chosenOrganizerUser, onActivate, onEdit, onInactivate]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <Table
      {...getTableProps()}
      style={{
        borderCollapse: 'separate',
        borderSpacing: '0 0.5rem',
        width: '100%',
      }}
      className='table-borderless'
    >
      <thead className='bg-divider'>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className={
                row.original.isActive ? 'bg-white' : 'bg-white inactive-tr'
              }
              style={{ borderStyle: 'none' }}
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className={cell.column.className}
                    style={cell.column.style}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default OrganizerUsersTable;
